import React, { useState, useEffect, useMemo } from "react"
import { v4 as uuidv4 } from "uuid"
import { Link } from "react-router-dom"
import Rating from "./Rating"
import { getAverageRating } from "../../util"
import AddToCartButton from "../AddToCartButton"
import WishListButton from "./WishListButton"
import { useDispatch, useSelector } from "react-redux"
import { fetchReviews } from "../../store"
import "../styles/homePageReviews.css"

const HomePageReviews = () => {
  const { reviews } = useSelector((state) => state.reviews)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchReviews())
  }, [])

  return (
    <div className="reviewsContainer">
      <div className="reviewsTitle">Reviews</div>
      {reviews.slice(0, 6).map((review) => {
        return (
          <div className="reviewItem">
            <div className="reviewContent">
              <h2 className="reviewerName">{review.user.username}</h2>
              <div className="productLink">
                <Link to={`/products/${review.product.id}`}>
                  {review.product.name}
                </Link>
              </div>
              <div className="reviewDescription">"{review.description}"!</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
export default HomePageReviews
